import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { WizardPage } from './pages/wizard/WizardPage';
import { GeneratedQuestionsPage } from './pages/GeneratedQuestionsPage';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { PricingPage } from './pages/PricingPage';
import { PaymentResultPage } from './pages/PaymentResultPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SessionExpiredDialog } from './components/auth/SessionExpiredDialog';
import { DASHBOARD_TABS, getDashboardTabPath } from './constants/dashboard';
import { LOGIN_PATH } from './constants/routes';

function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Outlet /> : <Navigate to={LOGIN_PATH} replace />;
}

const App: React.FC = () => {
  return (
    <AuthProvider>
      {/* Outside the router on purpose: an expired session has to be acknowledged on
          every route, and the dialog navigates with a full page load anyway. */}
      <SessionExpiredDialog />
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path={LOGIN_PATH} element={<LoginPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/payment/success" element={<PaymentResultPage result="success" />} />
          <Route path="/payment/fail" element={<PaymentResultPage result="fail" />} />
          <Route path="/payment/cancel" element={<PaymentResultPage result="cancel" />} />

          {/* Protected */}
          <Route element={<RequireAuth />}>
            <Route path="/" element={<DashboardPage />} />
            {/* Each dashboard tab is its own URL so tabs are linkable and survive a reload */}
            {DASHBOARD_TABS.map((tab) => (
              <Route key={tab} path={getDashboardTabPath(tab)} element={<DashboardPage />} />
            ))}
            <Route path="/wizard" element={<WizardPage />} />
            <Route path="/questions" element={<GeneratedQuestionsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
